import React, { FC } from "react";
import '../../styles/components/switch.scss';

interface MySwitchProps {
  checked: boolean;
  onChange: () => void;
}

export const Switch: FC<MySwitchProps> = ({ checked, onChange }) => {
  return (
    <label className="switch">
      <input 
        type="checkbox" 
        checked={checked} 
        onChange={onChange}
      />
      <span className="slider round" />
    </label>
  )
}